import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import paths from 'app/paths';
import GrantSysDuck from 'app/ducks/company-admin/grant-system';
import Link from 'app/components/common/link';
import format from 'app/helpers/format';
import formsHelpers from 'app/helpers/forms';
import Icon from 'app/components/common/icon';

class FormCard extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showPrograms: false,
    };

    this.onClickPrograms = this.onClickPrograms.bind(this);
  }

  onClickPrograms() {
    this.setState((prevState) => ({showPrograms: !prevState.showPrograms}));
  }

  render() {
    const {company, form, allPrograms, className, style} = this.props;
    const {showPrograms} = this.state;
    const programs = (allPrograms || []).filter(p => (p.formIds || []).includes(form.id));
    const isShared = !form.ownerId;

    return (          
      <div className={`ca-form-card style-${style} ${className}`}>
        <Link href={paths.cadminFormsEdit(company.slug, form.id)} className="btn xs secondary blue ca-form-card-btn">View/Edit</Link>
        <div className="ca-form-card-title">{form.title}</div>
        {isShared && (
          <div className="ca-form-card-shared" onClick={this.onClickPrograms}>
            <div className="ca-form-card-shared-chip">Shared</div>
            <div className="ca-form-card-shared-msg">{`Used in ${programs.length} ${format.pluralize('program', programs.length)}`}</div>
            <Icon.Caret direction={showPrograms ? 'up' : 'down'} className="ca-form-card-shared-caret" />
          </div>
        )}

        <div className="ca-form-card-scroller">
          {showPrograms && (<>
            <div className="ca-form-card-heading">{programs.length} {format.pluralize('program', programs.length)}</div>
            <div className="ca-form-card-progs">
              {programs.map((program) => {
                return (
                  <div key={program.id} className="ca-form-card-prog">
                    <Link href={paths.cadminGrantProgram(company.slug, program.id)} className="pink-hover">{program.title}</Link>
                  </div>
                );
              })}
            </div>
          </>)}
          <div className="ca-form-card-heading">{form.formFields.length} {format.pluralize('field', form.formFields.length)}</div>
          <div className="ca-form-card-fields">
            {form.formFields.map((field) => {
              const IconComp = formsHelpers.typeObjMap[field.type]?.icon || Icon.TextStyle;
              return (
                <div key={field.id} className="ca-form-card-field">
                  <IconComp /> <span className="ca-form-card-field-title">{field.title}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

}

FormCard.propTypes = {
  form: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
  className: PropTypes.string,
  style: PropTypes.oneOf(['box', 'border']),
};
FormCard.defaultProps = {
  className: '',
  style: 'box',
};

const stateToProps = (state) => ({
  allPrograms: GrantSysDuck.Slx.allPrograms(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(FormCard);
